import { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import ModalDialog from '../../common/components/ModalDialog';
import ButtonGroup from '../../common/components/ButtonGroup';

const RemoveSnoozeModal: FC<
  React.PropsWithChildren<RemoveSnoozeModalProps>
> = ({
  open,
  onCloseExcludeIssue,
  handleRemove,
  isLoading,
  issueName,
  children,
}) => {
  const theme = useTheme();

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Remove Snooze'
      open={open}
      onClose={onCloseExcludeIssue}
      modalHeader='Remove Snooze'>
      {children}
      <Box flexGrow={1} mb={2}>
        <Typography color='text.primary' variant='body1' component='div'>
          <p>{`Are you sure you want to remove the snooze from:`}</p>
          <b>{issueName}</b>
          <span>?</span>
        </Typography>
        <Typography color='text.primary' variant='body1' mt={0.5}>
          Please note that once the snooze is removed, this exclusion will never
          expire.
        </Typography>
      </Box>

      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={onCloseExcludeIssue}
          onClick={handleRemove}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Click to cancel'
          buttonActionLabel='Remove'
          buttonActionTooltip='Click to remove'
          isActionDisabled={false}
          isLoading={isLoading}
        />
      </Box>
    </ModalDialog>
  );
};

export interface RemoveSnoozeModalProps {
  open: boolean;
  onCloseExcludeIssue: () => void;
  handleRemove: () => void;
  isLoading: boolean;
  appName?: string;
  issueName?: string;
}

export default RemoveSnoozeModal;
